// extracted by mini-css-extract-plugin
module.exports = {"cardContainer":"card_cardContainer__1aABP","title":"card_title__1bW5z","inActive":"card_inActive__32F84"};